// 按页面划分
export default {
    // 公共页面
    common: {
        detail: '詳情',
        confirm: '確定',
        cancel: '取消',
        no_data: '暫無數據',
        no_data_text: '目前沒有可展示的數據',
        network_error: '發生錯誤',
        network_error_text: '我們正在努力解決，請稍後重試。',
        network_contact: '聯系我們',
        refresh: '刷新',
        comeback: '返回',
        comebackHasbutton: '返回，按鈕',
    },
    pullCom: {
        pull: '下拉可以刷新',
        release: '释放立即刷新',
        refresh: '正在刷新...'
    },
    index: {
        searchTip: '搜索國家/地區',
        exclusiveTit: '專屬優惠',
        more: '更多',
        mainlandTit: '中國內地專區',
        hkPackageTit: '中國香港專區',
        popularDestTit: '熱門目的地',
        countryList: {
            cn: '中国内地',
            singapore: '新加坡',
            hk: '中国香港',
            us: '美国',
            thailand: '泰国',
            germany: '德国',
            italy: '意大利',
            more: '更多'
        },
        regionalPackage: '跨區域流量',
        recommendPackage: '為您推薦',
        from: '起',
        guide: '新手指引',
        sepcialArea: '專區',
        lastUpdate: '上次更新',
        successRefresh: '刷新完成'
    },
    packages: {
        sub_title: {
            us: '不含關島、塞班島',
            it: '適用梵蒂岡、聖馬力諾',
            va: '適用意大利、聖馬力諾',
            sm: '適用意大利、梵蒂岡',
            ma: '適用西撒哈拉',
            eh: '適用摩洛哥',
            ch: '適用列支敦士登',
            li: '適用瑞士',
            fr: '適用摩納哥',
            mc: '適用法國',
            fi: '適用奧蘭群島',
            ax: '適用芬蘭',
            gu: '適用塞班島',
            mp: '適用關島'
        },
        unlimited_packages: '暢享包',
        normal_packages: '普通包',
        multi_region_packages: '含{area}的跨區域包',
        sale_text: '優惠',
        high_speed_text: '高速流量',
        high_speed_text_year: '高速流量/月',
        periodUnit: {
            day: '天',
            month: '月',
            hour: '小時',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '個月',
            hour: '小時',
            year: '年'
        },
        periodUnitSimp: {
            day: '天',
            month: '月',
            hour: '小時',
            year: '年'
        },
        periodUnitsSimp: {
            day: '天',
            month: '個月',
            hour: '小時',
            year: '年'
        },
        unlimited_good_name: {
            day: '包天暢享',
            month: '月畅享',
            year: '年畅享'
        },
        day_invalid: '當天失效',
        month_invalid: '當月失效',
        immediate_valid: '即時生效',
        tomorrow_day_valid: '次日生效',
        tomorrow_month_valid: '次月生效'
    },
    point: {
        title: '我的積分',
        point_history: '積分明細',
        my_point: '我的積分',
        will_expire_on: '積分有效期至',
        total: '總共',
        more: '更多',
        redeem_for_package: '兌換流量',
        redeem_for_balance: '兌換餘額',
        redeem_for_coupon: '兌換優惠券',
        points: '積分',
        dataPlans: '兌換流量',
        Balance: '兌換餘額',
        coupon: '兌換優惠券',
        signIn: '簽到',
        getPoint: '領積分',
        lottery: '积分 & 奖励',
        getPrizes: '贏禮品',
        membership_point_rules: '會員積分使用說明',
        got_it: '知道了',
        tabs: {
            all: '全部',
            earn: '獲得',
            redeem: '兌換'
        },
        upgradeApp: '請升級最新版APP'
    },
    member: {
        membership: '會員',
        hello_member: '你好, 會員',
        update: '升級',
        vip_member_benefits: 'VIP會員權益',
        packages: '流量包',
        discounts: '折扣',
        points: '積分',
        membership_policy: '會員協議',
        faq: '常見問題',
        update_to_vip_membership: '升級至VIP會員',
        vip_member: 'VIP會員',
        valid_till: '有效期至',
        renew: '續費',
        months: '個月',
        payment: '支付訂單',
        vip_membership: 'VIP會員',
        enjoy_vip_member_benefits: '尊享{len}大VIP會員權益！',
        by_purchasing_you_agree_to: '購買即代表同意',
        coupon: '優惠',
        available_coupon: '{num}個可用',
        no_available_coupon: '暫無優惠',
        actual_price: '實付金額',
        payment_success_text: '購買成功后，相關流量包即可自動到賬。',
        balance: '餘額',
        online_payment: '在線支付',
        faq_title: '常見問題',
        policy_title: '會員隱私',
        introduce_title: '會員介紹'
    },
    order: {
        periodUnit: {
            day: '天',
            month: '個月',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '個月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '確定支付嗎？',
            content: '您將使用餘額支付',
            noSelectPackageTitle: '未選擇套餐',
            noSelectPackageContent: '請先選擇一個套餐'
        },
        purcase_successful: '購買成功',
        vip_membership: 'VIP會員',
        total: '支付金額',
        finish_btn: '返回',
        get_order_status: '正在努力獲取訂單狀態...',
        order_status_tip: '支付待確認',
        order_status_note_user:
            '支付結果確認中，如10分鐘后還未到賬，請咨詢客服。',
        order_status_btn_text: '完成',
        ios_iap_pay_btn: '立即支付'
    },
    faq: {
        page_title: '常見問題',
        mydevice: '我的設備',
        more: '更多設備',
        more_faq: '更多問題',
        all_device: '全部設備',
        faq_detail: '詳情'
    },
    device: {
        page_title: '設備手冊'
    },
    vpn: {
        page_title: 'VPN常見問題',
        faq_detail: '詳情'
    },
    esim: {
        page_title: 'ESIM常見問題',
        faq_detail: 'ESIM詳情'
    },
    deviceGuide: {
        title: '請選擇你的設備',
        skip: '跳過'
    },
    give_set: {
        give_set_page_title: '贈送流量設置',
        give_set_page_set_btn: '儲存',
        title: '會員贈送套餐設置',
        desc:
            '升級會員成功後我們將會定期贈送流量包至您設置的設備上，未綁定設備將不能接收贈送流量包！',
        select_device_placeholder: '請選擇設備',
        select_device_title: '選擇設備',
        no_device_title: '你還未綁定設備',
        no_device_desc: '請選擇綁定設備類型',
        bind_type_by_scan: '掃描',
        bind_type_by_type: '按類型',
        disable_device_desc:
            '贈送流量包無法在您綁定的設備上使用，請綁定對應的設備',
        bind_device: '綁定設備',
        give_set_success: '設定成功',
        give_set_leave_desc: '當前設置未保存，確定離開當前頁面嗎？',
        give_guide_tip: '點擊這裡可編輯贈送流量設置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    },
    guide: {
        newUser: {
            title: '新手指引',
            top_bar: {
                device: '我要使用設備網絡',
                sim: '我要使用SIM卡網絡'
            },
            step: {
                title: '如何使用設備上網',
                bind_device: '綁定設備',
                buy_package: '購買流量',
                use: '開機使用'
            },
            sub_bar: {
                device: '設備',
                package: '流量',
                use: '使用'
            },
            content: {
                device: {
                    list: [
                        {
                            title: '如何綁定設備？',
                            content: [
                                {
                                    text:
                                        '用戶可在首次登入時綁定設備，或前往「設備」綁定，或在購買服務計劃時進行綁定。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '2. 綁定方法可以透過「掃碼綁定」，直接掃一掃設備背面的QR碼，有屏設備在「屏幕首頁」-「更多設定」中查看。或透過「依型號綁定」，選擇你的設備類型，依據指引進行綁定。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                }
                            ]
                        }
                    ]
                },
                package: {
                    list: [
                        {
                            title: '如何購買本地流動數據計劃？',
                            content: [
                                {
                                    text:
                                        '1、前往「商城」-「本地服務」，瀏覽商品資訊。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '2、點選「購買」，然後完成付款。如目前還未綁定設備，請先綁定設備後再購買服務計劃。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                }
                            ]
                        },
                        {
                            title: '如何購買全球流動數據計劃？',
                            content: [
                                {
                                    text:
                                        '1、前往「首頁」，點選「搜尋目的地與流量」，輸入準備前往的目的地。您可以根據需要靈活選擇服務計劃，單一國家、區域或全球流量，包天、7天或30天，5G或4G。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '2、點選「購買」，然後完成付款。如目前還未綁定設備，請先綁定設備後再購買服務計劃。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                }
                            ]
                        }
                    ]
                },
                use: {
                    list: [
                        {
                            title: '如何開始上網？',
                            content: [
                                {
                                    text:
                                        '1、購買本地服務計劃後，開啟設備將自動啟動服務計劃，已開啟的設備需重新啟動。',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '2、購買全球服務計劃後，在目的地開啟設備將自動啟動服務計劃，設備成功連接互聯網後即可自由上網。',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '（設備第一次連網時間大概需要2-3分鐘，請耐心等待）',
                                    imgSrc: '',
                                    desc: '',
                                    parentClass: '',
                                    class: '',
                                    type: 'tips'
                                }
                            ]
                        }
                    ]
                },
                sim: {
                    list: [
                        {
                            title: '如何使用SIM卡上網？',
                            content: [
                                {
                                    text:
                                        '1、按照說明書指引，將可用SIM卡插入設備卡槽後再重啟設備，即可正常使用（有屏設備需在設備屏幕上切換至SIM卡模式）',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                },
                                {
                                    text:
                                        '2、您還可以用手機連接設備的Wi-Fi，在App設備詳情頁，點擊SIM功能切換至SIM模式',
                                    imgSrc:
                                        'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                                    desc: '',
                                    parentClass: '',
                                    class: ''
                                }
                            ]
                        }
                    ]
                }
            }
        }
    },
    //paygo--开始
    'route.Home': '按流量計費',
    'route.rate': '國家或地區費率',
    'route.record': '歷史記錄',
    'common.nonedata': '暫無數據',
    'common.nonedataRate': '暫無費率信息',
    'common.more': '更多',
    'route.home.flowType': '按流量計費',
    'route.home.rateTit': '當前計費地區',
    'route.home.timeUse': '計費時長',
    'route.home.DataUse': '累計流量',
    'route.home.MoneyUse': '計費金額',
    'route.home.history': '查看扣費記錄 >',
    'route.home.OtherRate': '其他國家或地區費率',
    'route.home.useMethod': '使用方法',
    'route.home.addMinutes': '提前充值',
    'route.home.arrived': '到達目的地開機使用',
    'route.home.useRule': '使用規則',
    'route.home.updateTips': '你尚未升級至放心GO服務',
    'route.home.updateBtn': '立即升級',
    'route.home.updateBtn2': '立即升級',
    'route.home.LaterUpdateBtn': '晚點升級',
    'route.home.updateService': '升級服務',
    'route.home.updateSuccess': '升級成功',
    'route.home.country': '国家/地區',
    'route.home.cost': '資費',
    'route.home.TopCost': '封頂',
    'route.home.Success': '好',
    'route.home.where': '獲取不到位置',
    'route.home.ReLogin':
        '您已成功升級為放心GO服務！若您賬戶下有定額套餐，現已轉為疊加包。請返回APP重新登錄以刷新服務。溫馨提醒您出行前保證餘額充足',
    'route.home.ReLoginBtn': '去登錄',
    'route.home.flowTypeDesc':
        '無套餐可用時按流量計費。費率：{rateCurrency} {rate}/MB。(按流量計費時會臨時凍結一部分餘額)',
    'route.home.flowTypeDescLimit':
        '無套餐可用時按流量計費。費率：{rateCurrency} {rate}/MB，上限收費：{amountCurrency} {amount}。(按流量計費時會臨時凍結一部分餘額)',
    errorCode: {
        '01282001': '登錄用戶名或密碼錯誤',
        '01282002': '登錄用戶已停用',
        '01282003': '登錄用戶名為空',
        '01282004': '登錄密碼為空',
        '01282501': '代理商不存在',
        '01282503': '代理商已停用',
        '00000008': '登錄客戶與accessToken不匹配'
    },
    'paygo.basePayFlagMsg.true': '開啟成功',
    'paygo.basePayFlagMsg.false': '關閉成功',
    'paygo.a11y.enabled': '啟用',
    'paygo.a11y.disabled': '關閉',
    'paygo.a11y.labelAndroid': '{title}，當前狀態為{state}',
    'paygo.a11y.labelDefault': '{title}，{state}',
    'paygo.a11y.announceState': '{title}，{state}',
    'paygo.QueryFlowHistory.NullData': '暫無數據',
    //paygo---结束
    'msgPush.tips': '溫馨提醒',
    'msgPush.closePush': '關閉後，你可能會錯過我們的優惠活動等相關信息',
    'msgPush.confirm': '確定',
    'msgPush.cancel': '取消',
    'msgPush.appPush': 'app消息推送',
    'msgPush.emailPush': '郵件推送',
    'msgPush.loginFirst': '未登錄或登錄失效，如需繼續操作，請先登錄？'
}



// WEBPACK FOOTER //
// ./src/lang/zh-TW.js